/**
 * @fileoverview Story Planning domain - manages story setup, plot planning, and storyline structure.
 *
 * This domain handles:
 * - Story setup metadata (genre, POV, tense, story DNA)
 * - Plot ideation and planning artifacts
 * - Storyline planning and story questions
 * - Plot-level AI orchestration hooks and schemas
 * - Lore and world-building context
 *
 * @example
 * ```tsx
 * import { StoryStructure, useStoryPlanning, useStorylinePlanning } from '@/domains/story-planning';
 * ```
 */

export * from './schemas';
export * from './constants';
export { useStoryPlanning } from './hooks/use-story-planning';
